/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Account type determines which fields are used
 */
export type EntityBankAccountType = typeof EntityBankAccountType[keyof typeof EntityBankAccountType];


export const EntityBankAccountType = {
  iban: 'iban',
  us_domestic: 'us_domestic',
  uk_domestic: 'uk_domestic',
  other: 'other',
} as const;
